module.exports = __webpack_public_path__ + "static/img/2014.dab46066.jpg";